export default __webpack_public_path__ + "static/media/empty.790c0e31.svg";